import { Switch } from "@/components/ui/switch";
import { Slider } from "@/components/ui/slider";

type Props = { value: any; onChange: (v: any) => void };
export default function SettingsStep({ value, onChange }: Props) {
  return (
    <div className="grid gap-6">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-medium">Allow NSFW</div>
          <p className="text-xs text-muted-foreground">Enable adult context with safeguards.</p>
        </div>
        <Switch checked={value.nsfw} onCheckedChange={(v)=>onChange({...value, nsfw:v})} />
      </div>
      <div>
        <div className="mb-2 text-sm font-medium">Creativity</div>
        <Slider value={[Math.round(value.temperature*10)]} onValueChange={(v)=>onChange({...value, temperature:v[0]/10})} max={10} step={1} />
        <div className="mt-1 text-xs text-muted-foreground">Temperature: {value.temperature.toFixed(1)}</div>
      </div>
    </div>
  );
}
